// src/ImeiScanner.jsx

import React, { useEffect, useState, useRef } from 'react';
import { Html5QrcodeScanner } from 'html5-qrcode';

const ImeiScanner = () => {
  const [scanResult, setScanResult] = useState('');
  const [isZoomed, setIsZoomed] = useState(false);
  const [isFlashlightOn, setIsFlashlightOn] = useState(false);
  const scannerRef = useRef(null);
  const videoTrackRef = useRef(null); // Ref to store the video track

  // Function to get the video track from the scanner
  const getVideoTrack = () => {
    const videoElement = document.getElementById("reader").querySelector("video");
    if (videoElement && videoElement.srcObject) {
      return videoElement.srcObject.getVideoTracks()[0];
    }
    return null;
  };

  // Function to toggle the flashlight
  const toggleFlashlight = async () => {
    const track = videoTrackRef.current;
    if (track) {
      const capabilities = track.getCapabilities();
      if (capabilities.torch) {
        try {
          await track.applyConstraints({ advanced: [{ torch: !isFlashlightOn }] });
          setIsFlashlightOn(!isFlashlightOn);
        } catch (e) {
          console.error("Failed to toggle flashlight:", e);
        }
      } else {
        alert("Flashlight is not supported on this device.");
      }
    }
  };

  useEffect(() => {
    const onScanSuccess = (decodedText) => {
      setScanResult(decodedText);
      scannerRef.current.stop().then(() => console.log("Scanner stopped."));
    };

    const onScanFailure = (error) => {
      console.warn(`Scan failure: ${error}`);
      // You can add logic here to check for low light
      // This is a very basic heuristic: if scans fail for a few seconds, it might be dark
    };

    const config = {
      fps: 10,
      qrbox: { width: 300, height: 150 },
      disableFlip: false,
      video: {
        facingMode: "environment"
      }
    };

    const html5QrcodeScanner = new Html5QrcodeScanner("reader", config, false);
    scannerRef.current = html5QrcodeScanner;
    html5QrcodeScanner.render(onScanSuccess, onScanFailure);

    // Get the video track after the scanner has rendered
    const interval = setInterval(() => {
      const track = getVideoTrack();
      if (track) {
        videoTrackRef.current = track;
        clearInterval(interval);
      }
    }, 500);

    return () => {
      clearInterval(interval);
      if (scannerRef.current) {
        scannerRef.current.clear();
      }
    };
  }, []);

  const toggleZoom = () => {
    setIsZoomed(!isZoomed);
  };

  return (
    <div className="scanner-page">
      <h1>IMEI Scanner</h1>
      <p>Position the barcode within the box to scan it. The back camera is active.</p>
      
      <div className="scanner-container">
        <div id="reader" className={isZoomed ? 'zoomed' : ''}></div>
      </div>

      <div style={{ marginTop: '20px' }}>
        <button onClick={toggleZoom}>
          {isZoomed ? 'Zoom Out' : 'Zoom In'}
        </button>
        <button onClick={toggleFlashlight} style={{ marginLeft: '10px' }}>
          {isFlashlightOn ? 'Turn Flash Off' : 'Turn Flash On'}
        </button>
      </div>

      {scanResult && (
        <div className="scanned-result">
          <h3>Scanned IMEI Number:</h3>
          <p><strong>{scanResult}</strong></p>
        </div>
      )}
    </div>
  );
};

export default ImeiScanner;